export default "__VITE_ASSET__b1ce8ead__"